/**
 * Operations Queue — state vocabulary (v6.3).
 *
 * Nine states, all visually rendered in the gold palette only (no red /
 * green / blue). Each state has its own shape — the user learns the
 * shapes once and reads the queue at a glance.
 */

export const OPERATION_STATES = {
  active:           { label: 'Active',           glyph: 'dot-glow',   sort: 1, hint: 'Working item, your move' },
  pending_decision: { label: 'Pending Decision', glyph: 'chevron',    sort: 0, hint: 'Your call needed' },
  follow_up:        { label: 'Follow-Up',        glyph: 'curve',      sort: 2, hint: 'Re-engage after silence' },
  scheduled:        { label: 'Scheduled',        glyph: 'clock',      sort: 3, hint: 'Coming up on a specific date' },
  waiting:          { label: 'Waiting',          glyph: 'ring',       sort: 4, hint: "Someone else's turn" },
  delegated:        { label: 'Delegated',        glyph: 'arrow',      sort: 5, hint: 'Handed off' },
  blocked:          { label: 'Blocked',          glyph: 'dot-block',  sort: 6, hint: 'A blocker exists' },
  snoozed:          { label: 'Snoozed',          glyph: 'dashed',     sort: 7, hint: 'Deferred' },
  completed:        { label: 'Completed',        glyph: 'diamond',    sort: 8, hint: 'Done' },
};

export const OPERATION_FILTERS = [
  { id: 'today',     label: 'Today',     stateFilter: (op) => op.urgency === 'today' && op.state !== 'completed' && op.state !== 'snoozed' },
  { id: 'week',      label: 'This week', stateFilter: (op) => ['today', 'this_week'].includes(op.urgency) && op.state !== 'completed' && op.state !== 'snoozed' },
  { id: 'waiting',   label: 'Waiting',   stateFilter: (op) => op.state === 'waiting' || op.state === 'delegated' },
  { id: 'all',       label: 'All open',  stateFilter: (op) => op.state !== 'completed' },
  { id: 'snoozed',   label: 'Snoozed',   stateFilter: (op) => op.state === 'snoozed' },
];

export const CATEGORY_LABELS = {
  finance: 'Finance',
  vendors: 'Vendors',
  guests: 'Guests',
  communications: 'Communications',
  venue: 'Venue',
  logistics: 'Logistics',
  family: 'Family',
  other: 'Other',
};

export function urgencyLabel(urgency) {
  return ({
    today: 'Today',
    this_week: 'This week',
    this_month: 'This month',
    when_possible: 'When possible',
  })[urgency] || urgency;
}

export function formatDueDate(iso) {
  if (!iso) return null;
  try {
    const date = new Date(iso + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.round((date - today) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'Today';
    if (diffDays === 1) return 'Tomorrow';
    if (diffDays > 1 && diffDays <= 6) {
      return date.toLocaleDateString('en-US', { weekday: 'long' });
    }
    if (diffDays > 6 && diffDays <= 60) {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    if (diffDays < 0 && diffDays >= -3) return `${Math.abs(diffDays)} d ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch {
    return iso;
  }
}
